class BrowseLeftPanelController {
    constructor(categoriesService) {
        this.categoriesService = categoriesService;
    }

    shouldDisplayBacklink() {
        if (this.isSpecial) {
            this.backlinkCategory = this.getBacklinkCategory();
            this.specialCategory = this.categoriesService.getSpecialCategory(this.category);
            return this.backlinkCategory && this.backlinkCategory !== this.specialCategory;
        }

        if (this.isBundle) {
            this.bundleCategory = this.categoriesService.getBundleCategory(this.category);
            return this.departmentCategory !== this.bundleCategory;
        }

        return this.departmentCategory !== this.category;
    }

    getBacklinkCategory() {
        return this.isSpecial && this.departmentCategory.IsSpecial
            ? this.categoriesService.getFirstSpecialCategory(this.departmentCategory)
            : this.departmentCategory;
    }
}

const browseLeftPanelComponentDefinition = {
    bindings: {
        departmentCategory: '<',
        category: '<',
        isSpecial: '<',
        isBundle: '<',
    },
    controller: ['CategoriesService', BrowseLeftPanelController],
    template: require('./browse-left-panel.component.html').trim(),
};

module.exports = {
    BrowseLeftPanelController,
    browseLeftPanelComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/browse/browse-left-panel.component.js